<template>
  <div class="h-80 bg-0 pd-lr-300 top-sticky">
    <el-row :gutter="20" type="flex" justify="space-between" class="h100 align-items-center">
      <el-col :lg="4" :span="4" class="bg-0">
        <el-dropdown v-if="screenSize == 'lg'" ref="myDropdown" class="right-menu-item bg-0" trigger="click"
          :hide-on-click="false">
          <span class="el-dropdown-link fs-10 color-f">
            {{ $t('message.cd') }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-tabs tab-position="left" style="width: 97vw;background: #000;color: #fff;">
                <el-tab-pane :label="$t('header.menu0')">
                  <overview type="produce"></overview>
                </el-tab-pane>
                <el-tab-pane :label="$t('header.menu1')">
                  <overview type="mark"></overview>
                </el-tab-pane>
                <el-tab-pane :label="$t('header.menu2')">
                  <overview type="salesSupport"></overview>
                </el-tab-pane>
                <el-tab-pane :label="$t('header.menu3')">
                  <overview type="about"></overview>
                </el-tab-pane>
              </el-tabs>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div v-else class="cd relative">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAH1JREFUSEvtlbENgDAQA+2Kjl0YBhZgLhaAYdiFjsoUNEiAgvKSC5L0/yc7p4QwHZo4qKDspm/VSRoBdNkbz8GV5HTd8QSaAfRB0EJySIE8iYJJXscL0FtSC6AJVriT3FIy2KyzgTzVBe+mcL09T5Akm3WeRNW6rw3875s4ABkDMhsD5fWXAAAAAElFTkSuQmCC"
            alt="" @click="handleShowMenu">
          <el-collapse ref="myCollapse" v-show="active" v-model="activeNames" accordion class="collapse-small">
            <el-collapse-item class="ddd" v-for="(nav) in navRoot" :key="nav.type" :title="$t(nav.name)"
              :name="nav.type">
              <ul>
                <li v-for="(item, index) in initNavList(nav.type)" :key="index"
                  :class="item.className ? item.className : 'son'" @click="jumpTo(item)">
                  {{ $t(item.name) }}
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="center" @click="jumpTo({ route: 'home' })">
          <img class="w-rem-12 h-rem-2" alt="" src="../assets/img2/logo-CK3Ah_zb.png">
        </div>
      </el-col>
      <el-col :lg="2" :span="4" class="flex-end">
        <Lang class="right-menu-item"></Lang>
      </el-col>
    </el-row>


  </div>
</template>
<script>
import router from "../router";
import Lang from "./Lang/index.vue";
import Overview from "./Overview.vue";
export default {
  name: "Header",
  components: { Lang, Overview },
  provide() {
    return { hideDropdrow: this.hideDropdrow };
  },
  computed: {
    navList() {
      return this.initOverView
    }
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      options: [],
      props: {
        value: 'value',
        label: 'label'
      },
      active: false,
      navRoot: [
        { name: 'header.menu0', type: 'produce' },
        { name: 'header.menu1', type: 'mark' },
        { name: 'header.menu2', type: 'salesSupport' },
        { name: 'header.menu3', type: 'about' }
      ],
      activeNames: 'produce'
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    screenSize() {
      return this.$store.getters.screenSize
    },
    navList() {
      return this.initNavList()
    }
  },
  mounted() {

  },
  methods: {
    initNavList(type) {
      let overObj = {}
      let list = []
      if (type === 'produce') {
        overObj = {
          name: 'route.rou1',
          route: 'Produce',
          imgUrl: 'cpzx-rP_JuD7r',
          imgDesc: "header.spe6",
        }
        list = [
          [
            {
              name: 'EMMC.name',
              route: 'ProduceType',
              className: 'spec',
              params: {
                itemType: 'embedding'
              }
            },
            {
              name: 'productCenter.embedding.emmc.name',
              fixedName: 'EMMC',
              route: 'ProduceInfo',
              params: {
                item: 'emmc'
              }
            },
            {
              name: 'productCenter.embedding.ufs.name',
              fixedName: 'UFS',
              route: 'ProduceInfo',
              params: {
                item: 'ufs'
              }
            },
            {
              name: 'productCenter.embedding.sip-ic.name',
              route: 'ProduceInfo',
              params: {
                item: 'sip-ic'
              }
            }
          ],
          [
            {
              name: 'M2.name',
              route: 'ProduceType',
              params: {
                itemType: 'rdimm'
              }
            },
            {
              name: 'header.spe0',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-25'
              }
            },
            {
              name: 'M2.zl',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-m2'
              }
            },
            {
              name: 'Special Conn SSD',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-sc'
              }
            },
            {
              name: 'header.spe1',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-ent'
              }
            },
            {
              name: 'header.spe2',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-server'
              }
            },
          ],
          [
            {
              name: 'FB.name',
              route: 'ProduceType',
              params: {
                itemType: 'sd'
              }
            },
            {
              name: 'FB.zl',
              route: 'ProduceInfo',
              params: {
                item: 'dsd'
              }
            },
            {
              name: 'header.spe3',
              route: 'ProduceInfo',
              params: {
                item: 'csd'
              }
            },
            {
              name: 'header.spe4',
              route: 'ProduceInfo',
              params: {
                item: 'csc-rack'
              }
            },
            {
              name: 'header.spe5',
              route: 'ProduceInfo',
              params: {
                item: 'ida'
              }
            },
          ]
        ]
      } else if (type === 'mark') {
        overObj = {
          name: 'header.menu4',
          route: 'Mark',
          imgUrl: 'scyhy-D8o1Ve7V',
          imgDesc: "header.spe7",
        }
        list = [
          [
            {
              name: 'Solution.so0',
              route: 'IndustryPage',
              className: 'spec',
              params: {
                item: 'dataCenter'
              }
            },
            {
              name: 'Solution.so2',
              route: 'IndustryPage',
              params: {
                item: 'PC'
              }
            },
            {
              name: 'Solution.so4',
              route: 'IndustryPage',
              params: {
                item: 'CAR'
              }
            },
            {
              name: 'Solution.so6',
              route: 'IndustryPage',
              params: {
                item: 'MobilePhone'
              }
            },
            {
              name: 'Solution.so8',
              route: 'IndustryPage',
              params: {
                item: 'AI'
              }
            }
          ],
          [
            {
              name: 'Solution.so10',
              route: 'IndustryPage',
              params: {
                item: 'Smart'
              }
            },
            {
              name: 'Solution.so12',
              route: 'IndustryPage',
              params: {
                item: 'Network'
              }
            },
            {
              name: 'Solution.so14',
              route: 'IndustryPage',
              params: {
                item: 'Industrial'
              }
            }
          ]
        ]
      } else if (type === 'salesSupport') {
        overObj = {
          name: 'header.menu5',
          route: 'SalesSupport',
          imgUrl: 'xsyzc-CLpAfVhZ',
          imgDesc: "header.spe8",
        }
        list = [
          [
            {
              name: 'header.menu5',
              route: 'SalesSupport',
              className: 'spec',
            }
          ]
        ]
      } else if (type === 'about') {
        overObj = {
          name: 'message.ab',
          route: 'about',
          imgUrl: 'gywm-KwURyTex',
          imgDesc: "header.spe9",
        }
        list = [
          [
            {
              name: 'header.spe10',
              route: 'AboutView',
              className: 'spec',
            },
            {
              name: 'header.spe11',
              route: 'MyCaption'
            },
            {
              name: 'header.spe12',
              route: 'ContUs'
            },
            {
              name: 'header.spe13',
              route: 'NewsView'
            }
          ]
        ]
      }

      return list.flat(1)

    },
    router() {
      return router
    },
    goHome() {
      this.menuClass = 0;
      this.$router.push('/')
    },
    dsb(ite) {
      this.menuClass = 0;
      this.$router.push(ite.route)
    },
    navClick(item) {
      if (item.path != null) {
        this.menuClass = 0;
        this.$router.push(item.path);
      } else {
        if (this.er !== 0) {
          this.er = 0;
        } else {
          this.er = item.id;
        }
      }
    },
    menu() {
      if (this.menuClass === 0) {
        this.menuClass = 1;
      } else {
        this.menuClass = 0;
        this.er = 0;
      }
    },
    jumpTo(item) {
      this.$router.push({ name: item.route, params: item.params || {} })
      if (this.$refs.myCollapse) this.active = false
    },
    hideDropdrow() {
      // 手动关闭下拉菜单（通过 ref 调用 hide() 方法）
      this.$refs.myDropdown.hide();
    },
    handleShowMenu() {
      this.active = !this.active;
    }
  }
};
</script>
<style lang="scss" scoped>
.top-sticky {
  position: sticky;
  top: 0;
  z-index: 999;

}

::v-deep .el-tabs__header .el-tabs__item {
  background: #fff3;
  font-size: 20rem;
  cursor: pointer;
  padding-left: 1.25rem;
  width: 18.75rem 300px;
  height: 3.75rem;
  line-height: 3.75rem;
  font-weight: 500;
  font-size: 1.25rem;
  color: #fff;
}

::v-deep .el-dropdown-menu .el-tabs--left .el-tabs__item.is-left {
  color: #fff;
  font-size: 2rem;
}

.collapse-small {
  position: absolute;
  width: 94vw;
  top: 4rem;
  left: -2rem;
  overflow-y: auto;
  max-height: 50vh;
}

.collapse-small ::v-deep .el-collapse-item .el-collapse-item__header {
  background: #333;
  color: #fff;
}

.collapse-small ul {
  li {
    color: #000;
    background: #fff;
    border-bottom: 1px #ddd solid;
    font-size: 1.6rem;

    &.spec {
      display: block;
      padding: 1.3rem 1.6rem;

      background: #c3c3c3;
    }

    &.son {
      color: #000;
      padding: 0.8rem 3rem;
      border-bottom: 1px #ddd solid;
    }
  }

}

.ddd ::v-deep .el-collapse-item__header {
  background: #333;
  color: #fff;

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue